export default "__VITE_ASSET__Yuv_KVo3__"